export default __webpack_public_path__ + "static/media/leadership-img.05eb243d.png";